<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="1"
      width="25.6158"
      height="25.6158"
      rx="6.62495"
      stroke="currentColor"
      stroke-width="0.567486"
    />
    <path
      d="M10.2652 14.8688L18.2773 10.4043C18.4185 10.3201 18.5802 10.1183 18.8133 10.2648C19.0384 10.4063 18.6714 10.6345 18.6149 10.6871C16.731 12.4393 12.9086 15.2287 12.2308 15.7231C11.553 16.2175 11.834 16.5584 12.0592 16.6529C13.9817 18.1238 17.8042 20.9696 18.2773 21.1512C18.7504 21.3328 19.1238 20.8527 19.181 20.5334C20.1592 16.5425 22.0823 8.38013 21.9489 7.65814C21.8155 6.93615 21.1616 6.90438 20.8513 6.97874C15.8193 8.87309 5.5296 12.7176 5.21849 13.1114C4.81528 13.6219 5.09448 13.8252 5.4418 13.9577L8.77818 15.0184C9.27326 15.1758 9.81137 15.1217 10.2652 14.8688Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "TelegramIcon"
};
</script>
